'use client'

// Animation
import { motion } from 'framer-motion'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import {
  ButtonLG,
  Container,
  fadeInUp,
  Section,
  staggerContainer,
} from 'design-studio'

// Layout
import Link from 'next/link'
// UI components
import { SectionHeader } from '@/components/ui/section-header'
import { CodeLogicianLogo } from '@/components/ui/logos/codelogician'

export function CodeLogicianSection() {
  return (
    <Section
      className="relative scroll-mt-32 overflow-hidden bg-slate-200/5 py-16 pb-28 sm:pt-24 sm:pb-44 lg:pt-48 lg:pb-90 dark:bg-gray-900/5"
      id="codelogician"
    >
      <Container className="relative max-w-6xl">
        {/* <Spotlight
          color="from-teal-600/50"
          className="-top-250 -right-256 z-0 size-512"
        /> */}
        {/* 
        <Spotlight
          color="from-cyan-500/10"
          className="-bottom-200 -left-200 z-0 size-384"
        /> */}

        <motion.div
          variants={staggerContainer}
          initial="initial"
          whileInView="animate"
          viewport={{ once: true, amount: 0.2 }}
          className="relative z-10 space-y-10"
        >
          <motion.div variants={fadeInUp}>
            <SectionHeader
              pretitle="Neurosymbolic AI"
              srOnlyFullHeading="Checkout Imandra CodeLogician.dev"
              title="Checkout Imandra CodeLogician.dev"
              description={
                <div className="mt-6 flex flex-col items-start gap-3 lg:ml-18 xl:ml-26">
                  <CodeLogicianLogo
                    variant="white"
                    className="h-8 w-auto text-white"
                  />
                  <span className="font-display dark:text-slate-300">
                    Our neurosymbolic reasoning agent, built on ImandraX —
                    combining LLM coding agents with formal reasoning to
                    systematically analyze software behavior, catch edge cases,
                    and ship with confidence instead of guesswork.
                  </span>
                </div>
              }
              pretitleColor="text-teal-400/80"
            />
          </motion.div>

          <motion.div variants={fadeInUp} className="flex">
            <ButtonLG
              href="https://codelogician.dev"
              variant="none"
              classNames="w-fit font-display border border-teal-500/50 bg-teal-950/40 text-teal-100 font-semibold whitespace-nowrap backdrop-blur-sm hover:bg-teal-900/50 hover:border-teal-400/70 hover:text-white transition-colors"
            >
              Read more about CodeLogician
              <FontAwesomeIcon
                icon={faArrowRight}
                className="h-4 w-4 -translate-x-1 opacity-0 transition-all duration-200 ease-out group-hover:translate-x-1 group-hover:opacity-100"
              />
            </ButtonLG>
          </motion.div>
        </motion.div>
      </Container>
    </Section>
  )
}
